import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { Radio } from '../../models/radio';
import { Radios } from '../../data/radios';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { Feed } from '../../models/feed';
import { HttpClient } from '@angular/common/http';
// tslint:disable-next-line:label-position


@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.css']
})
export class RadioComponent implements OnInit {
  radioCollection = [] ;
  currentRadio = new Radio();
  currentIndex = 0;
  showNews = false;
  data = null;
  feeds: Feed[] = [];
  countries = [];
  @ViewChild('videoPlayer') videoplayer: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    protected http: HttpClient,
    @Inject(DOCUMENT) private document: any
    ) {
     // super();
  }


  ngOnInit() {
    this.radioCollection = Radios;
    this.setCountries();
    if (this.route.snapshot.params.id === undefined && this.route.snapshot.params.id !== -1) {
      this.currentRadio = this.radioCollection[this.currentIndex + 1];
      } else {
        if (this.route.snapshot.params.id !== '-1') {
         this.setRadio(this.route.snapshot.params.id);
        }
      }
      if (this.route.snapshot.params.id === '-1' ) {
       this.showNews = true;
       const res =  this.http.get('https://cors-anywhere.herokuapp.com/' + 'http://www.diario.aw/feed/', {responseType: 'text'}).subscribe(
           response => {
       this.data = response;
       this.readXml(response);
     // const jsonText = JSON.stringify(this.xmlToJson(response));
     // const myObjRes = JSON.parse(response);
   },
    error => {
      //this.loading = false;
   });
      }
      this.videoplayer.nativeElement.play();
  }

  setCountries() {
    this.countries.push('Aruba');
    this.countries.push('Bonaire');
    this.countries.push('Curacao');
  }

  setNewsInfo() {
    this.showNews = true;
       const res =  this.http.get('https://cors-anywhere.herokuapp.com/' + 'http://www.diario.aw/feed/', {responseType: 'text'}).subscribe(
           response => {
       this.data = response;
       this.readXml(response);
   });
  }

  setRadioInfo() {
    this.showNews = false;
  }

  next() {
    if   (this.radioCollection.length >=  this.currentIndex ) {
    this.currentIndex = this.currentIndex + 1;
    this.currentRadio = this.radioCollection[this.currentIndex];
    this.router.navigate(['/Radio/' + this.currentRadio.id]);
    this.videoplayer.nativeElement.play();
    window.location.reload();
   // this.document.location.href = 'http://basilachill.eu/Radio/' + this.currentRadio.id;
    }
  }

  prev() {
    if (this.currentIndex >= 0) {
    this.currentIndex = this.currentIndex - 1;
    this.currentRadio = this.radioCollection[this.currentIndex];
    this.router.navigate(['/Radio/' + this.currentRadio.id]);
    this.videoplayer.nativeElement.reload();
    window.location.reload();
  //  this.document.location.href = 'http://basilachill.eu/index.html/Radio/' + this.currentRadio.id;
    }
  }

  readXml(res: string) {
    const result =  res.split('<title>');
    let i = 0;
    for (let j = 0; j < result.length; j++) {
      if (j > 1 && j < 10) {
       const result2 = result[j].split('</title>');
       const newFeed = new Feed();
       newFeed.title = result2[0];
       newFeed.id = i.toString();
       i = i + 1;
       this.feeds.push(newFeed);
      }
    }
   }

  setRadio(id: string) {
    for (let index = 0; index < this.radioCollection.length; index++) {
      const element = this.radioCollection[index];
      if (element.id === id) {
       this.currentRadio = this.radioCollection[index];
      }
    }

  }

}
